module.exports = __webpack_public_path__ + "static/media/Logo.fdefd708.svg";